export const seoIntro = {
  tag: "Pandabuy Sheet",
  title: "The Ultimate PandabuySpreadsheet Finds Database",
  description: "A pandabuy spreadsheet is a carefully curated collection of product links and finds organized into an easy-to-navigate database. Instead of spending hours scrolling through forums and social media threads, smart shoppers use our pandabuy spreadsheet to discover trending fashion items, compare quality ratings instantly, and save money on every purchase. Our pandabuy spreadsheet is updated daily with fresh finds across all major categories including shoes, hoodies, t-shirts, jackets, accessories, and more — making it the most comprehensive resource for anyone who loves curated fashion discovery.",
  buttonText: "Read Full SEO Article",
  articlePath: "/article/pandabuy-spreadsheet-guide",
  mainSiteLink: "https://kaspreadsheet.com",
};

export const trustStats = [
  { value: "10,000+", label: "Curated Items" },
  { value: "Daily", label: "Updated" },
  { value: "14", label: "Categories" },
  { value: "Verified", label: "Community" },
];